//
// A DeferredPromise is a promise that can be resolved or rejected from outside of the promise's scope.
// Used for async/await functions that need to stall until a condition is met.
//
export class DeferredPromise<T = void> implements Promise<T> {
  [Symbol.toStringTag]: string;

  private promise: Promise<T>;

  private _resolve: (value?: T | PromiseLike<T>) => void;
  private _reject: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  then<TResult1 = T, TResult2 = never>(
    onfulfilled?: (value: T) => TResult1 | PromiseLike<TResult1>,
    onrejected?: (reason: any) => TResult2 | PromiseLike<TResult2>
  ): Promise<TResult1 | TResult2> {
    return this.promise.then(onfulfilled, onrejected);
  }
  catch<TResult = never>(onrejected?: (reason: any) => TResult | PromiseLike<TResult>): Promise<T | TResult> {
    return this.promise.catch(onrejected);
  }

  finally(onfinally?: () => void): Promise<T> {
    return this.promise.finally(onfinally);
  }

  resolve(value?: T | PromiseLike<T>) {
    this._resolve(value);
  }

  reject(reason?: any) {
    this._reject(reason);
  }
}
